'use client';

import NextLink from 'next/link';
import { twMerge } from 'tailwind-merge';

import type { LinkProps as NextLinkProps } from 'next/link';

type LinkProps = NextLinkProps &
  React.AnchorHTMLAttributes<HTMLAnchorElement> & {
    children: React.ReactNode;
    className?: string;
  };

export default function Link({ children, className, ...props }: LinkProps) {
  return (
    <NextLink
      className={twMerge(
        'text-primary underline hover:text-content-secondary focus-visible:text-content-secondary',
        className
      )}
      onClick={(e) => {
        e.stopPropagation();
      }}
      {...props}
    >
      {children}
    </NextLink>
  );
}
